import React, { Component } from 'react';
import {
    Text,
    BlockStack,
    Badge,
    Button,
    Pagination,
    Spinner,
    Modal,

} from '@shopify/polaris';
import '../index.css';
import Language from '../../../../../i18n/Language';
import TableFilters from '../../../../../components/TableFilters';
import IndexTableImage from './IndexTableImage';
import FooterPageSelect from '../../../../../components/FooterPageSelect';

const t = Language;
class ManaullyModal extends Component {
    state = {
        isShowManuallyModal: this.props.isShowManuallyModal,    // 弹窗状态
        Headings: [
            { title: '' },
            { title: t("Name") },
            { title: t("Status") },
        ],                                                      // 表格标题
        tableRes: this.props.tableRes,                          // 分页及列表
        tableData: this.props.tableData,                        // 表格列表
        mCheckState: false,                                     // 是否开启选择
        queryValue: this.props.queryValue,                      // 搜索内容
        tabKey: this.props.tabKey,                              // 标题id
        tableLoading: this.props.tableLoading,                  // 手动表格loading
        page: this.props.page,
        pageSize: this.props.pageSize,
        manuallyPre: this.props.manuallyPre,                     // 上页
        manuallyNext: this.props.manuallyNext,                   // 下页
        isShowImgCompression: this.props.isShowImgCompression,
        isShowImgAltText: this.props.isShowImgAltText,
        isShowImgFilename: this.props.isShowImgFilename,
        ConvertImg: this.props.ConvertImg,
        AddWaterImg: this.props.AddWaterImg,
        is_default: this.props.is_default,                       // 是否第一次设置
        image_opt: this.props.image_opt,                        // 初始设置数据
        alt_text: this.props.alt_text,                          // 初始设置数据
        file_name: this.props.file_name,                        // 初始设置数据
        isImageCompression: this.props.isImageCompression,                              // 开启状态
        isConvertImage: this.props.isConvertImage,
        isAddWatermark: this.props.isAddWatermark,
        isImageAlttext: this.props.isImageAlttext,
        isImageFilename: this.props.isImageFilename,
    }

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isShowManuallyModal !== this.props.isShowManuallyModal) {
            this.setState({
                isShowManuallyModal: nextProps.isShowManuallyModal,
                is_default: nextProps.is_default,
            })
        }
        if (nextProps.tabKey !== this.props.tabKey) {
            this.setState({
                tabKey: nextProps.tabKey,
            })
        }
        if (nextProps.tableData !== this.props.tableData) {
            this.setState({
                tableData: nextProps.tableData,
                tableRes: nextProps.tableRes,
            })
        }
        if (nextProps.tableLoading !== this.props.tableLoading) {
            this.setState({
                tableLoading: nextProps.tableLoading,
            })
        }
        if (nextProps.queryValue !== this.props.queryValue) {
            this.setState({
                queryValue: nextProps.queryValue,
            })
        }
        if (nextProps.image_opt !== this.props.image_opt) {
            this.setState({
                image_opt: nextProps.image_opt,
                alt_text: nextProps.alt_text,
                file_name: nextProps.file_name,
            })
        }
        if (nextProps.isImageCompression !== this.props.isImageCompression) {
            this.setState({
                isImageCompression: nextProps.isImageCompression,
            })
        }
        if (nextProps.isConvertImage !== this.props.isConvertImage) {
            this.setState({
                isConvertImage: nextProps.isConvertImage,
            })
        }
        if (nextProps.isAddWatermark !== this.props.isAddWatermark) {
            this.setState({
                isAddWatermark: nextProps.isAddWatermark,
            })
        }
        if (nextProps.isImageAlttext !== this.props.isImageAlttext) {
            this.setState({
                isImageAlttext: nextProps.isImageAlttext,
            })
        }
        if (nextProps.isImageFilename !== this.props.isImageFilename) {
            this.setState({
                isImageFilename: nextProps.isImageFilename,
            })
        }
        if (nextProps.manuallyPre !== this.props.manuallyPre) {
            this.setState({
                manuallyPre: nextProps.manuallyPre,
            })
        }
        if (nextProps.manuallyNext !== this.props.manuallyNext) {
            this.setState({
                manuallyNext: nextProps.manuallyNext,
            })
        }
        if (nextProps.page !== this.props.page) {
            this.setState({
                page: nextProps.page,
            })
        }
        
        return true;
    }

    // 打开设置
    openSetupBoxBack = () => {
        this.props.openSetupBox();
    }

    // 关闭弹窗
    handleStateChangeBack = (name, val) => {
        this.props.handleStateChange(name, val);
    }

    // 切换tab
    handleTypeTabsChange = (e) => {
        this.props.changeManuallyTab(e);
    }

    // 搜索
    setQueryValue = (val) => {
        this.props.changeManuallyQueryVal(val);
    }

    // 获取批量数据
    getTableItemState = (data) => {
        this.setState({
            tableItemState: data
        }, () => {
            this.props.setManuallyTableItemData(data)
        })
    }

    // 开始批量
    OptimizeNowManaully = () => {
        this.props.handleOptManaully();
    }

    // 分页
    changeManuallyPage = (e) => {
        this.props.changeManuallyPageData(e);
    }

    // 改变页面条数
    changePageSizeData = (s) => {
        this.props.changeManuallyPageSizeData(s);
    }

    render() {
        const {
            Headings,
            tableData,
            mCheckState,
            queryValue,
            tabKey,
            isShowManuallyModal,
            tableLoading,
            tableRes,
            page,
            manuallyPre,
            manuallyNext,
            is_default,
            isImageCompression,
            // isConvertImage,
            isAddWatermark,
            isImageAlttext,
            isImageFilename,

        } = this.state;

        const wwidth = window.innerWidth; // 屏幕宽度
        const startNum = ((tableRes.current_page - 1) * tableRes.per_page) + 1;
        const endNum = tableRes.current_page * tableRes.per_page <= tableRes.total ? tableRes.current_page * tableRes.per_page : tableRes.total;
        const total = tableRes.total;
        const footerContentText = wwidth > 550 ? <FooterPageSelect current_PageSize={tableRes.per_page} changePageSize={this.changePageSizeData} startNum={startNum} endNum={endNum} total={total} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);

        // 手动弹窗
        const manuallySetModal = <Modal
            size='large'
            open={isShowManuallyModal}
            onClose={() => this.handleStateChangeBack('isShowManuallyModal', false)}
            title={t("Manually optimization")}
        >
            {/* <Modal.Section> */}
                <div className='manually_set_modal'>
                    <BlockStack gap={300}>
                        <TableFilters
                            loading={tableLoading}
                            itemStrings={[
                                t("Product"),
                                t("Collection"),
                                t("Blog"),
                            ]}
                            queryValue={queryValue}
                            typeSelected={tabKey}
                            setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
                            setQueryValue={(v) => this.setQueryValue(v)}
                        />
                        <div className='manually_set_tip modal_set_tip'>
                            <Text as="p" fontWeight="medium">
                                {t("SEOAnt will optimize your store's images based on your settings. You can also click here to")}
                                &nbsp;
                                <Button onClick={this.openSetupBoxBack} variant='plain' textAlign="left">{t("modify the settings")}.</Button>
                                &nbsp;
                                {t("Don't worry about making mistakes, as you can always restore them at any time.")}
                            </Text>
                        </div>
                        <div className='manually_func_state flex_layout'>
                            <div className='flex_layout'>{t("Image compression")} <Badge tone={isImageCompression ? 'success' : ''}>{isImageCompression ? t("On") : t("Off")}</Badge></div>
                            {/* <div className='flex_layout'>{t("Conver PNG to JPG")} <Badge tone={isConvertImage ? 'success' : ''}>{isConvertImage ? t("On") : t("Off")}</Badge></div> */}
                            <div className='flex_layout'>{t("Add watermark")} <Badge tone={isAddWatermark ? 'success' : ''}>{isAddWatermark ? t("On") : t("Off")}</Badge></div>
                            <div className='flex_layout'>{t("Image alt text")} <Badge tone={isImageAlttext ? 'success' : ''}>{isImageAlttext ? t("On") : t("Off")}</Badge></div>
                            <div className='flex_layout'>{t("Image filename")} <Badge tone={isImageFilename ? 'success' : ''}>{isImageFilename ? t("On") : t("Off")}</Badge></div>
                        </div>
                        <div className={`${tableData.length >= 5 && 'manually_table_list'}`}>
                            {
                                tableLoading ? <div className='table_loading'>
                                    <Spinner />
                                </div> :
                                (is_default === 1 || (!Boolean(isImageCompression) && !Boolean(isAddWatermark) && !Boolean(isImageAlttext) && !Boolean(isImageFilename))) ? <div className='manually_empty'>
                                    <BlockStack gap={400} inlineAlign="center">
                                        <Text variant="headingLg" as="h2">
                                            {t("No optimization setting for")}
                                            &nbsp;{tabKey === 0 ? t("product") : tabKey === 1 ? t("collection") : t("blog")}&nbsp;
                                            {t("images")}.
                                        </Text>
                                        <Text as="p" color="subdued">
                                            {t("You should first set up the settings for optimizing")}
                                            &nbsp;{tabKey === 0 ? t("product") : tabKey === 1 ? t("collection") : t("blog")}&nbsp;
                                            {t("images")}.
                                        </Text>
                                        <div><Button variant="primary" onClick={this.openSetupBoxBack}>{t("Go to set up")}</Button></div>
                                    </BlockStack>
                                </div> : <IndexTableImage
                                    id={`Manually_Table_${tabKey}`}
                                    tabKey={tabKey}
                                    headings={Headings}
                                    dataList={tableData}
                                    checkState={mCheckState}
                                    total={total}
                                    obj_name={tabKey === 0 ? 'products' : tabKey === 1 ? 'collections' : 'blogs'}
                                    getTableItemState={this.getTableItemState}
                                    promotedBulkActions={[
                                        {
                                            content: t("Optimize now"),
                                            onAction: this.OptimizeNowManaully
                                        },
                                    ]}
                                    tableType={'manually'}
                                />
                            }
                        </div>
                        {
                            (is_default === 1 || (!Boolean(isImageCompression) && !Boolean(isAddWatermark) && !Boolean(isImageAlttext) && !Boolean(isImageFilename)) || tableLoading) ? null :
                                (tableData.length > 0 && <div className='justify_center sticky_footer'>
                                    <Pagination
                                        label={footerContentText}
                                        hasPrevious={manuallyPre}
                                        onPrevious={() => this.changeManuallyPage(page - 1)}
                                        hasNext={manuallyNext}
                                        onNext={() => this.changeManuallyPage(page + 1)}
                                    />
                                </div>)
                        }
                    </BlockStack>
                </div>
            {/* </Modal.Section> */}
        </Modal>

        return manuallySetModal;
    }
}

export default ManaullyModal;

